<button
    qpxButton
    matButton
    [size]="isPhone() ? 'sm' : 'md'"
    class="trigger text-heading-lg! leading-8!"
    [matMenuTriggerFor]="headerMenu"
    [attr.data-testid]="activeItem()?.testId || null"
>
    <span>{{ activeItem()?.label ?? '' }}</span>
    <ng-icon qpx name="lucideChevronDown" matButtonIcon iconPositionEnd />
</button>

<mat-menu #headerMenu="matMenu" [attr.aria-label]="ariaLabel()">
    @for (item of items(); track item.key) {
        <a
            mat-menu-item
            [routerLink]="item.route"
            [class]="
                item.key === activeKey()
                    ? 'bg-primary-muted! text-primary-muted!'
                    : ''
            "
            [attr.aria-current]="item.key === activeKey() ? 'page' : null"
            [attr.data-testid]="item.testId || null"
        >
            <span>{{ item.label }}</span>
        </a>
    }
</mat-menu>
